"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Placeholder = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var Indicators = __importStar(require("../Indicators"));
var Form_1 = require("../Form");
var CONTAINER_STYLES = "flex h-screen w-full p-3 items-center content-center";
var MODAL_STYLES = "m-auto border-2 border-rose-dark rounded-lg p-5 flex";
var CONTENT_STYLES = "relative text-center flex flex-grow flex-col align-center items-center text-rose-darkest";
var TITLE_STYLES = "text-rose-darkest text-center font-bold text-md mt-2";
var SUBTITLE_STYLES = "text-rose-darkest font-body text-sm";
var BUTTON_STYLES = "mt-3";
var Placeholder = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, icon = _a.icon, action = _a.action, onClick = _a.onClick, loading = _a.loading;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: CONTAINER_STYLES }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: MODAL_STYLES, style: { minWidth: 144, minHeight: 144, maxWidth: 480 } }, { children: (0, jsx_runtime_1.jsxs)("article", __assign({ className: CONTENT_STYLES }, { children: [icon ? (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: icon, size: "4x" }, void 0) : null, title ? (0, jsx_runtime_1.jsx)("h1", __assign({ className: TITLE_STYLES }, { children: title }), void 0) : null, subtitle ? (0, jsx_runtime_1.jsx)("p", __assign({ className: SUBTITLE_STYLES }, { children: subtitle }), void 0) : null, onClick ? ((0, jsx_runtime_1.jsx)(Form_1.Button, __assign({ onClick: onClick, appearance: "secondary", className: BUTTON_STYLES }, { children: action !== null && action !== void 0 ? action : "Continue" }), void 0)) : null, loading ? (0, jsx_runtime_1.jsx)(Indicators.AbsoluteOverlay, {}, void 0) : null] }), void 0) }), void 0) }), void 0));
};
exports.Placeholder = Placeholder;
